import { Amplify } from 'aws-amplify';
import { environment } from '../../environments/environment';
import { jwtDecode } from 'jwt-decode';

/**
 * Configures Amplify with the AppSync API endpoints
 * Note: This does NOT configure Amplify Auth - we're keeping Cognito authentication
 * outside of Amplify as per requirements
 */
export function configureAmplify() {
  // Configure Amplify with AppSync endpoints
  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: environment.appsync.httpEndpoint,
        region: environment.cognito.region,
        defaultAuthMode: 'none',
      }
    }
  }, {
    API: {
      GraphQL: {
        headers: async () =>  {
          const token = getAuthToken();
          return {
            Authorization: token ? `Bearer ${token}` : '',
            "sec-websocket-protocol" : ["graphql-ws"],
            host: environment.appsync.httpEndpoint.replace('https://', '').replace('http://', '').replace('appsync-api.', '').replace('/graphql', '')
          };
        }
      }
    }
  });
}

/**
 * Gets the authentication token from localStorage
 * This is used by Amplify to authenticate GraphQL requests
 */
export function getAuthToken(): string | null {
  const token = localStorage.getItem('auth_token');

  // Validate token before returning
  if (token) {
    try {
      // Decode the token to check if it's valid and not expired
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp && decoded.exp > currentTime) {
        return token;
      } else {
        console.warn('Token is expired');
        return null;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  return null;
}
